import { Component, HostListener, Input, OnInit } from '@angular/core';

@Component({
  selector: 'paragraph-wysiwyg',
  templateUrl: './paragraph-wysiwyg.component.html',
  styleUrls: ['./paragraph-wysiwyg.component.css'],
})
export class ParagraphWysiwygComponent implements OnInit {
  @Input() value: any;

  constructor() {}

  ngOnInit(): void {
    // console.log(this.value)
  }
}
